/* eslint-disable promise/param-names */
import {
  PUBLISHERS_REQUEST,
  PUBLISHERS_REPLACE,
  PUBLISHER_GET_NEW_ID,
  PUBLISHER_UPDATE,
  PUBLISHER_SAVE,
  PUBLISHERS_SUCCESS,
} from '@/store/actions/publishers';

import Vue from 'vue'

import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/firestore';

const state = { 
  publishers: [],
  status: '', 
  hasLoadedOnce: false,
};

const getters = {
  publishers: state => state.publishers ? state.publishers : [],
  publishersLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [PUBLISHERS_REQUEST]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(PUBLISHERS_REQUEST)
    
      firebase.firestore().collection('publishers').orderBy('name')
        .onSnapshot(querySnapshot => {
          let publishers = []

          querySnapshot.docChanges().forEach(change => {
            publishers.push(change.doc.data())
          })

          if (state.hasLoadedOnce == false) {
            commit(PUBLISHERS_SUCCESS, publishers)
          } else {
            commit(PUBLISHERS_REPLACE, publishers)
          }

          resolve();
        })
    })
  },

  [PUBLISHER_UPDATE]: ({commit, dispatch}, args) => {
    commit(PUBLISHERS_REQUEST)

    return firebase.firestore().collection('publishers').doc(args.publisher.id).update({
      name: args.value
    }).then(() => {
      commit(PUBLISHERS_SUCCESS)
    })
  },

  [PUBLISHER_SAVE]: ({commit, dispatch}, publisher) => {
    commit(PUBLISHERS_REQUEST)

    return new Promise( async (resolve, reject) => {
      await firebase.firestore().collection("publishers").doc(String(publisher.id)).set(publisher)
        .then(res => {
          commit(PUBLISHERS_SUCCESS)
          resolve()
        }).catch(err => {
          reject(err)
        })
    })
  },

  [PUBLISHER_GET_NEW_ID]: ({commit, dispatch}) => {
    commit(PUBLISHERS_REQUEST)

    return new Promise( (resolve, reject) => {
      var getNewPublisherId = firebase.functions().httpsCallable('getNewPublisherId');
      getNewPublisherId().then(result => {
        commit(PUBLISHERS_SUCCESS)
        resolve(result.data)
      }).catch(err => {
        reject(err)
      })
    });
  },
}

const mutations = {
  [PUBLISHERS_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [PUBLISHERS_SUCCESS]: (state, publishers) => {
    state.status = 'success'
    if ( publishers!= undefined) {
      state.publishers = publishers
      state.hasLoadedOnce = true
    }
  },

  [PUBLISHERS_REPLACE]: (state, publishers) => {
    publishers.forEach(publisher => {
      let rowIndex = state.publishers.findIndex(elem => elem.id == publisher.id)
      if (rowIndex != -1) {
        Vue.set(state.publishers, rowIndex, publisher)
      } else {
        state.publishers.push(publisher)
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
